import { render, staticRenderFns } from "./IndicadoresProcesoPagination.vue?vue&type=template&id=13b88a68&"
import script from "./IndicadoresProcesoPagination.vue?vue&type=script&lang=js&"
export * from "./IndicadoresProcesoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports